export enum AddRundownCuePosition {
  BEFORE = 'before',
  AFTER = 'after',
}

/**
 * Grid column id of a cue's heading (title) cell. Navigation addresses the
 * title as a column with this id. It is not a column type, see `ColumnType` in
 * `~shared/rundown/column`.
 */
export const HEADING_COLUMN_ID = 'heading-column'
